import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Modal } from 'react-bootstrap';
import secureStorage from "../../config/encrypt";
import CustomPagination from '../elements/CustomPagination';
import ModalBuySubscriptions from  './ModalBuySubscriptions';
import PaymentStatus from '../skusTransactions/PaymentStatus';

const DealerSubscriptionList = (props) => {
    const { t } = useTranslation("dealer_sku_pannel");
    const location = useLocation();
    const history = useHistory();
    const query = new URLSearchParams(location.search);
    const status = query.get("status");
    const [buyOptions, setBuyOptions] = useState([]);
    const [modelOwnerType, setModelOwnerType] = useState(''); // Owner could be delaer or admin.
    const [modelData, setModelData] = useState({});
    const [isModelEnable, setIsModelEnable] = useState(false);
    const [showPaymentStatusModal, setShowPaymentModelStatus] = useState(false);

    const loginResponse = secureStorage.getItem('loginUserInfo');
    const userData = loginResponse && loginResponse?.data && loginResponse?.data?.user_data || {};
    const dealerData = loginResponse && loginResponse?.data && loginResponse?.data?.dealer_data || {};
    const userId = userData?.user_id || 0;
    const dealerIDHash = dealerData[0]?.dealer_id_hash || '';
    const userRole = userData && userData?.role;
    const isAdmin = userRole === 'admin';

    useEffect(() => {
        if (props.buyOptions) {
            setBuyOptions(props.buyOptions);
        }
    }, [props]);

    useEffect(() => {
        if (status) {
            setShowPaymentModelStatus(true);
        } else {
            setShowPaymentModelStatus(false);
        }
    }, [status]);

    const handlePaymentStatusModal = () => {
        setShowPaymentModelStatus(false);
        history.replace("/dealer-subscriptions")
    }

    const handleBuySubscriptionModel = (modelOwner, updateObj) => {
        setIsModelEnable(true);
        setModelOwnerType(modelOwner);
        setModelData(updateObj);
    };

    const handleModelClose = () => {
        setIsModelEnable(false);
        setModelOwnerType('');
        setModelData({});
    }

    return (
        <div>
            <h2>Buy Subscriptions</h2>
            <table className="table-style-2">
                <thead>
                    <tr>
                        <th>Subscription</th>
                        <th>Quota</th>
                        <th>Bump up</th>
                        <th>Featured</th>
                        <th>Total Leads</th>
                        <th>Validity</th>
                        <th>Discount</th>
                        <th>Price</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {buyOptions.map((option, idx) => (
                        <tr key={idx}>
                            <td>{option.name}</td>
                            <td>{props?.skuTYpes?.find((sType) => sType.label === 'Buyer Listing' && +sType.value === +option.sku_type)? option.quota : '-'}</td>
                            <td>{props?.skuTYpes?.find((sType) => sType.label === 'Bumpup SKU' && +sType.value === +option.sku_type) ? option.quota : '-'}</td>
                            <td>{props?.skuTYpes?.find((sType) => sType.label === 'Featured Listing' && +sType.value === +option.sku_type) ? option.quota : '-'}</td>
                            <td>{option.total_leads}</td>
                            <td>{`${option.active_period_days} Days`}</td>
                            <td>
                                <span className="discounted">{`Rp ${option?.discount_to_be_shown?.toLocaleString() || 0}`}</span>{" "}
                            </td>
                            <td>
                                <span className="original">{`Rp ${(+option.price || 0)?.toLocaleString()}`}</span>
                            </td>
                           { isAdmin && <td>
                                <button
                                    className="btn-solid w-auto btn-sm bg-orange t-uppercase"
                                    onClick={() => handleBuySubscriptionModel('admin', { package_details: option, sku_types: props?.skuTYpes, dealer_id_hash: dealerIDHash, fetchEditData: props?.fetchEditData })}
                                > Activate
                                </button>
                            </td>}
                           {!isAdmin && <td>
                                <button
                                    className="btn-solid w-auto btn-sm bg-orange t-uppercase"
                                    onClick={() => handleBuySubscriptionModel('dealer', { package_details: option, sku_types: props?.skuTYpes, dealer_id_hash: dealerIDHash, fetchEditData: props?.fetchEditData })}
                                >Buy Now
                                </button>
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* When no Records available */}
            {!props.isLoading && buyOptions.length === 0 ? (
                <>
                    <div align="center" className="center" style={{ marginTop: "20px" }}>
                        <h6 className="text-center text-danger text-bold">{t("Listing.NO_RECORD_FOUND")}</h6>
                    </div>
                </>
            ) : null}
            {/* End No Records found */}

            {buyOptions.length > 0 && <CustomPagination
                currentPage={props.currentPage}
                totalPages={props.totalPages}
                onPageChange={props.onPageChange}
            />}

            <Modal show={isModelEnable} onHide={handleModelClose} className='modal-subscription new-theme' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Buy Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalBuySubscriptions 
                        data={modelData}
                        userType={modelOwnerType}
                        handleClose={handleModelClose}
                        isAdmin={isAdmin}
                    />
                </Modal.Body>
            </Modal>

            {showPaymentStatusModal ? <PaymentStatus status={status} handleClose={handlePaymentStatusModal} /> : null} 
        </div>
    );
};

export default DealerSubscriptionList;